import React from 'react';

import Button from '../../Button/Button';
import DialogActions from '../../DialogActions/DialogActions';

type Props = {
  onClear: () => void;
  onCancel: () => void;
  onAccept: () => void;
  onSetToday: () => void;
  ownerState: {
    disabled: boolean;
  };
  actions: string[];
  hidden?: boolean;
};

export default function CustomActionBar({
  onClear,
  onCancel,
  onAccept,
  onSetToday,
  actions,
  hidden,
  ownerState,
  ...other
}: Props) {
  const actionMap = {
    today: {
      onClick: onSetToday,
      text: 'Today',
      variant: 'text',
    },
    clear: {
      onClick: onClear,
      text: 'Clear',
      variant: 'text',
    },
    cancel: {
      onClick: onCancel,
      text: 'Cancel',
      variant: 'outlined',
    },
    accept: {
      onClick: onAccept,
      text: 'OK',
      variant: 'contained',
    },
  };

  return (
    !!actions?.length &&
    !hidden && (
      <DialogActions {...other}>
        {actions.map((actionKey) => {
          const buttonOptions = actionMap[actionKey as keyof typeof actionMap];

          return buttonOptions ? (
            <Button
              key={actionKey}
              variant={buttonOptions.variant as 'text' | 'outlined' | 'contained'}
              color="primary"
              onClick={buttonOptions.onClick}
              disabled={!!ownerState?.disabled}
              style={{
                marginRight: actionKey === 'today' ? 'auto' : undefined,
              }}
            >
              {buttonOptions.text}
            </Button>
          ) : null;
        })}
      </DialogActions>
    )
  );
}
